export const sideModal = ['w-full', 'top-0', 'right-0', 'h-full', 'side-modal']
export const centeredModal = ['m-0.5', 'sm:m-3', 'md:m-10', 'lg:m-16', 'w-full']

export const xl4 = '70rem'
export const xl3 = '60rem'
export const xl2 = '50rem'
export const xl = '40rem'
export const lg = '35rem'
export const md = '28rem'
